import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ExamLayer from "../components/ExamLayer";

const ExamPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Create Exam" />

        {/* ExamLayer */}
        <ExamLayer />
      </MasterLayout>
    </>
  );
};

export default ExamPage;
